module.exports = __webpack_public_path__ + "img/kr-product-footer.0732f49.png";